"use client";
// Precios vigentes de la base para las pantallas del navegador (una sola consulta por visita). Mientras llegan, o si no hay servidor,
// se ve el precio del catálogo; al llegar se reemplaza por el que de verdad se cobra.
import { useEffect, useState } from "react";
import type { MapaPrecios } from "@/lib/precios-publicos";

let pendiente: Promise<MapaPrecios | null> | null = null;
const pedir = () => (pendiente ??= fetch("/api/sitio/precios").then((r) => (r.ok ? r.json() : null)).catch(() => null));

export function usePreciosVigentes(): MapaPrecios | null {
  const [mapa, setMapa] = useState<MapaPrecios | null>(null);
  useEffect(() => { if (process.env.NEXT_PUBLIC_EXPORT === "1") return; let vivo = true; void pedir().then((m) => { if (vivo) setMapa(m); }); return () => { vivo = false; }; }, []);
  return mapa;
}
